import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '../api.service';
import { DayReport } from '../../models/dayreport';
import { Week } from '../../models/week';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class ReportingService {

    constructor(private api: APIService) {
    }

    getDetailedReportData(email: string, dateFrom: string, dateTo?: string): Observable<ReturnObject<DayReport[]>> {
        return this.api.getAPI(`reporting/detailedreport/${email.toUpperCase()}/${dateFrom}/${dateTo}`);
    }
    //----
    getGroupMonthReportData(email: string, yearMonthString: string, groupId: number): Observable<ReturnObject<DayReport[]>> {
        return this.api.getAPI(`reporting/monthreport/${yearMonthString}/${groupId}`);
    }

    getGroupWeekdReportData(email: string, weekNo: string, groupId: number ): Observable<ReturnObject<DayReport[]>> {
        return this.api.getAPI(`reporting/weekreport/${weekNo}/${groupId}`);
    }
    
    getProjectReportData(projectNo: string, dateFrom: string, dateTo?: string): Observable<ReturnObject<DayReport[]>> {
        return this.api.getAPI(`reporting/projreport/${projectNo}/${dateFrom}/${dateTo}`);
    }

    getProjectReportDataForEmp(projectNo: string, email: string, dateFrom: string, dateTo?: string): Observable<ReturnObject<DayReport[]>> {
        return this.api.getAPI(`reporting/projreport/${projectNo}/${email}/${dateFrom}/${dateTo}`);
    }

    getReportedWeekstData(): Observable<ReturnObject<Week[]>> {
        return this.api.getAPI(`reporting/reportedweeks`);
    }
}
